import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Plus } from 'lucide-react';
import PipelineClientCard from './PipelineClientCard';

const PipelineStageColumn = ({
  stage,
  clients,
  dragOverStage,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragStart,
  onTaskToggle,
  onDeleteClient
}) => {
  return (
    <div
      className={`flex-shrink-0 w-72 transition-colors ${
        dragOverStage === stage.id ? 'ring-2 ring-blue-400 ring-offset-2 rounded-lg' : ''
      }`}
      onDragOver={(e) => onDragOver(e, stage.id)}
      onDragLeave={onDragLeave}
      onDrop={(e) => onDrop(e, stage.id)}
      data-testid={`pipeline-stage-${stage.id}`}
    >
      <Card className="h-full">
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div 
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: stage.color }}
              />
              <CardTitle className="text-sm font-medium">{stage.name}</CardTitle>
            </div>
            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
              {clients.length}
            </span>
          </div>
        </CardHeader>
        <CardContent className="space-y-2 min-h-[200px]">
          {clients.map(client => (
            <PipelineClientCard
              key={client.assignmentId}
              client={client}
              stage={stage}
              onDragStart={onDragStart}
              onTaskToggle={onTaskToggle}
              onDeleteClick={onDeleteClient}
            />
          ))}
          {clients.length === 0 && (
            <div className="text-center py-8 text-gray-400 text-sm">
              No clients in this stage
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PipelineStageColumn;
